<template>
  <div class="block">
    <div
      class="block-header block-header-default d-flex flex-fill justify-content-between"
    >
      <h3 class="block-title">Spec Sheets</h3>
    </div>
    <div class="block-content pb-3">
      <div class="row">
        <div class="col col-sm-12 col-md-12">
          <div class="tab-pane show active" role="tabpanel">
            <v-expansion-panels v-model="openPanel" dense>
              <v-expansion-panel
                v-for="campaign in data.campaigns"
                class="v-expansion-panel--bordered"
              >
                <v-expansion-panel-header
                  :ref="`campaign-${campaign.id}-closer`"
                  class="font-weight-medium"
                  @click="editCampaign(campaign)"
                >
                  {{ campaign.name }}
                  <template v-slot:actions>
                    <v-icon>
                      mdi-chevron-down
                    </v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <form
                    v-if="campaign.form"
                    :id="'campaign-form-' + campaign.id"
                    :key="'campaign-form-' + campaign.id"
                    autocomplete="off"
                  >
                    <v-divider class="mb-4 mt-n1"></v-divider>
                    <v-row>
                      <v-col md="6" xs="12">
                        <bw-field
                          v-for="field in getFields(0)"
                          v-show="shouldShow(field)"
                          :key="campaign.id + '_' + field.id"
                          ref="fields"
                          :field="field"
                          :parent-id="campaign.id"
                          @field-changed="fieldChanged"
                        ></bw-field>
                      </v-col>
                      <v-col md="6" xs="12">
                        <bw-field
                          v-for="field in getFields(1)"
                          v-show="shouldShow(field)"
                          :key="campaign.id + '_' + field.id"
                          ref="fields"
                          :field="field"
                          :parent-id="campaign.id"
                          @field-changed="fieldChanged"
                        ></bw-field>
                      </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row>
                      <v-col class="text-right">
                        <button
                          class="btn btn-light"
                          @click="cancelCampaign(campaign)"
                        >
                          Cancel
                        </button>
                        <button class="btn btn-success" @click="saveCampaign">
                          Save
                        </button>
                      </v-col>
                    </v-row>
                  </form>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-sm-12 col-md-6">
          <button class="btn btn-success" @click="newCampaign">New</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      campaigns: [],
      filters: {},
      campaign: null,
      error_msg: '',
      success_msg: '',
      newCampaignId: 0,
      isUpdating: false,
      openPanel: null // all start open
    };
  },
  methods: {
    editCampaign(campaign) {
      this.campaign = campaign;
      this.$nextTick(() => {
        this.setUpForm();
      });
    },

    setUpForm() {
      if (!this.campaign.form || this.campaign.setUp) return;

      this.campaign.form.fieldAssignments.forEach(field => {
        if (field.value_options && typeof field.value_options === 'string')
          field.value_options = JSON.parse(field.value_options);

        if (field.field_path) {
          const paths = field.field_path.split('.');
          if (this[paths[0]] && this[paths[0]][paths[1]])
            field.value = this[paths[0]][paths[1]];
        } else {
          if (!this.campaign.fieldValues) this.campaign.fieldValues = [];
          const foundValue = this.campaign.fieldValues.find(
            x => x.field_id == field.id
          );
          if (foundValue) field.value = JSON.parse(foundValue.value);
        }

        // signal dependents
        setTimeout(() => {
          this.fieldChanged({ field, value: field.value });
        }, 250);
      });
      this.campaign.form.fieldAssignments.sort(
        (a, b) => a.sort_order - b.sort_order
      );

      // this.$refs.fields &&
      this.$refs.fields.forEach(fieldRef => {
        fieldRef.$forceUpdate();
      });
      this.$forceUpdate();
      this.campaign.setUp = true;
    },
    validateField(field, validate) {
      field.validation_settings = field.validation_settings
        ? typeof field.validation_settings === 'string'
          ? JSON.parse(field.validation_settings)
          : field.validation_settings
        : {};
      if (field.required) field.validation_settings.required = true;
      if (field.regexp) field.validation_settings.regex = field.regexp;

      const messages = {};
      Object.keys(field.validation_settings).forEach(key => {
        let m = '';
        switch (key) {
          case 'required':
            m = 'This is required';
            break;
          case 'minlength':
            m = `Please enter at least ${field.validation_settings.minlength} characters.`;
            break;
          case 'maxlength':
            m = `This can not be more than ${field.validation_settings.maxlength} characters.`;
            break;
          case 'regex':
            m = 'Invalid format.';
            break;
          case 'passwordMatch':
            m = 'Passwords must match.';
            break;
        }
        messages[key] = m;
      });
      validate.rules[`field-${field.id}`] = field.validation_settings;
      delete validate.rules[`field-${field.id}`].originallyHidden;
      validate.messages[`field-${field.id}`] = messages;
    },
    fieldChanged({ field, value, refId }) {
      // check if we should update other items
      if (field.field_path) {
        const paths = field.field_path.split('.');
        if (!this[paths[0]]) this[paths[0]] = {};
        this[paths[0]][paths[1]] = value;
      }
      this.checkDependents(field);

      this.$refs.fields.forEach(fieldRef => {
        fieldRef.$forceUpdate();
      });
      this.$forceUpdate();
    },
    checkDependents(field) {
      // check for dependents
      const depFields = this.campaign.form.fieldAssignments.filter(
        x =>
          x.dependent_settings &&
          x.dependent_settings.groups.length &&
          !!x.dependent_settings.groups.find(
            y => y.fieldAssignmentId === field.fieldAssignmentId
          )
      );
      depFields.forEach(f => {
        f.shouldShow = false;
        let str = '';
        f.dependent_settings.groups.forEach(g => {
          g.passed = false;
          let checkField;
          if (g.fieldAssignmentId !== field.fieldAssignmentId) {
            this.campaign.form.pages.forEach(page => {
              checkField = page.find(
                x => x.fieldAssignmentId === g.fieldAssignmentId
              );
            });
          } else checkField = field;

          if (
            checkField &&
            checkField.value &&
            checkField.value.toLowerCase() === g.fieldValue.toLowerCase()
          )
            g.passed = true;

          str += `${g.passed} ${
            f.dependent_settings.logic === 'AND' ? '&& ' : '|| '
          }`;
        });

        if (str.length)
          f.shouldShow = eval(`(${str.substring(0, str.length - 3)})`);
      });
    },
    shouldShow(field) {
      return typeof field.dependencyHide !== 'undefined'
        ? !field.dependencyHide
        : !field.validation_settings ||
            !field.validation_settings.originallyHidden;
    },
    newCampaign() {
      if (!this.data.campaigns) this.data.campaigns = [];

      const campaign = {
        id: --this.newCampaignId,
        form: this.data.form,
        name: 'New Campaign'
      };

      // New campaign panel open by default, call before push so we don't have
      // do subtract one ;)
      this.openPanel = this.data.campaigns.length;

      this.data.campaigns.push(campaign);

      this.editCampaign(campaign);
    },
    isValid() {
      const validate = { rules: {}, messages: {} };
      this.campaign.form.fieldAssignments.forEach(field => {
        this.validateField(field, validate);
      });
      const validation = $(`#campaign-form-${this.campaign.id}`).validate(
        validate
      );

      if (!$(`#campaign-form-${this.campaign.id}`).valid()) {
        validation.focusInvalid();
        return false;
      }

      return true;
    },
    saveCampaign() {
      if (!this.isValid()) return;

      this.isUpdating = true;
      const campaign = { id: this.campaign.id }; // only pass back what the form is modifying
      if (this.campaign.form) {
        campaign.customFields = [];
        this.campaign.form.fieldAssignments.forEach(field => {
          if (!field.field_path) campaign.customFields.push(field);
          else {
            const paths = field.field_path.split('.');
            if (paths[0] === 'campaign')
              campaign[paths[1]] = this.campaign[paths[1]];
          }
        });
      }

      if (campaign.id <= 0) delete campaign.id;

      let url = `/campaigns`;
      if (campaign.id) {
        url += `/${campaign.id}`;
        axios
          .put(url, campaign)
          .then(response => {
            const { data } = response;
            this.success_msg = 'Campaign updated successfully.';
            this.isUpdating = false;
          })
          .catch(error => {
            this.error_msg =
              (error.response.data && error.response.data.message) || 'Error';
            this.isUpdating = false;
          });
      } else {
        axios
          .post(url, campaign)
          .then(response => {
            const { data } = response;
            this.success_msg = 'Campaign saved successfully.';
            this.isUpdating = false;
          })
          .catch(error => {
            this.error_msg =
              (error.response.data && error.response.data.message) || 'Error';
            this.isUpdating = false;
          });
      }
    },
    cancelCampaign(campaign) {
      // $(`#campaign-${this.campaign.id}`).trigger('click');
      // console.log(this.$refs);
      // this.$refs[`campaign-${campaign.id}-closer`].click();
      this.openPanel = null;
      // $('html,body').animate({
      //   scrollTop: $(`#campaign-${this.campaign.id}`).offset().top - 100
      // });
      this.campaign = null;
    },
    getFields(page) {
      if (this.campaign?.form?.fieldAssignments) {
        return this.campaign.form.fieldAssignments.filter(
          x => x.sort_page == page
        );
      }

      return [];
    }
  },
  mounted() {
    if (this.data.filters) this.filters = this.data.filters;

    this.openPanels = [];

    $(document).ready(() => {
      // should these be global?
      jQuery.validator.addMethod(
        'regex',
        (value, element, regexp) => {
          if (!$(element).data('required') && !value) return true;

          let exp = regexp;
          let flags = '';
          if (exp[0] == '/') {
            const j = exp.lastIndexOf('/');
            if (j > -1) {
              exp = regexp.substr(1, j - 1);
              flags = regexp.substr(j + 1);
            }
          }
          const re = new RegExp(exp, flags);
          return re.test(value);
        },
        'Please check your input.'
      );
    });
  },
  watch: {
    success_msg(msg) {
      if (msg) {
        One.helpers('notify', {
          align: 'center',
          type: 'success',
          icon: 'fa fa-check mr-1',
          message: msg
        });
        this.success_msg = '';
      }
    },
    error_msg(msg) {
      if (msg) {
        One.helpers('notify', {
          align: 'center',
          type: 'danger',
          icon: 'fa fa-exclamation mr-1',
          message: msg
        });
        this.error_msg = '';
      }
    }
  }
};
</script>
